import React from 'react'
import { css } from 'emotion'
import styled from 'react-emotion'

import Button from '../buttons/Button'
import MobileIsometric from './mobile-phone-vector'
import DesktopIsometric from './desktop-vector'
import GraphIsometric from './graph-vector'

const ShowMobile = styled.div`
  @media (min-width: 767px) {
    display: none;
  }
`

const ShowTabletUp = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: flex;
  }
`

const HowItWorksContainer = css`
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
  
  @media (min-width: 767px) {
    margin-bottom: 0;
    flex-direction: row;
    display: block;
  }
`

const MobileIsometricWrapper = css`
  padding: 4%;

  @media (min-width: 767px) {
    width: 25%;
    display: inline-block;
  }

  @media (min-width: 1025px) {
    padding: 2rem 6%;
    width: 20%;
    display: inline-block;
  }
`

const Col = css`
  padding: 4%;

  @media (min-width: 767px) {
    width: 25%;
    display: inline-block;
  }

  @media (min-width: 1025px) {
    padding: 1rem 6%;
    width: 20%;
    display: inline-block;
  }
`

const HowItWorksActivate = css`
  text-align: center;
`

const explainerButton = css`
  margin-top: 2rem;
  
  @media (min-width: 767px) {
    margin-top: 0;
    margin-left: 1rem;
  }
`

const Desc = (props) => (
  <div>
    <h4>{props.header}</h4>
    <p>{props.description}</p>
  </div>
)

const HowItWorks = (props) => {
  return (
    <div>
      <div className={HowItWorksContainer}>
        <div className={MobileIsometricWrapper}>
          <div>
            <MobileIsometric />
          </div>
          <ShowMobile>
            <Desc
              header="Personalized and Automated Guest Engagement, from Booking to Departure"
              description="Drive Guest Engagement and Satisfaction throughout their entire journey!"
            />
          </ShowMobile>
        </div>
        <div className={MobileIsometricWrapper}>
          <div>
            <DesktopIsometric />
          </div>
          <ShowMobile>
            <Desc
              header="Digital Front Office Platform"
              description="All Guest Communications, Team Collaboration, Service Requests, Work Orders, Purchases, and more!"
            />
          </ShowMobile>
        </div>
        <div className={MobileIsometricWrapper}>
          <div>
            <GraphIsometric />
          </div>
          <ShowMobile>
            <Desc
              header="Satisfaction Goes Up, Costs Come Down"
              description="Automating mundane processes means less work and more instant gratification. Let us do the heavy lifting!"
            />
          </ShowMobile>
        </div>
      </div>

      <div>
        <ShowTabletUp>
          <div className={Col}>
            <Desc
              header="Personalized and Automated Guest Engagement, from Booking to Departure"
              description="Drive Guest Engagement and Satisfaction throughout their entire journey!"
            />
          </div>
          <div className={Col}>
            <Desc
              header="Digital Front Office Platform"
              description="All Guest Communications, Team Collaboration, Service Requests, Work Orders, Purchases, and more!"
            />
          </div>
          <div className={Col}>
            <Desc
              header="Satisfaction Goes Up, Costs Come Down"
              description="Automating mundane processes means less work and more instant gratification. Let us do the heavy lifting!"
            />
          </div>
        </ShowTabletUp>
      </div>

      <div className={HowItWorksActivate}>
        <Button to="/schedule">Activate Yours Today</Button>
        <Button className={explainerButton} flat to="/#how-it-works" onClick={() => props.toggleVideo()}>Watch Explainer Video</Button>
      </div>
    </div>
  )
}
 
export default HowItWorks;


// WEBPACK FOOTER //
// ./src/components/main/HowItWorks.js